import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { Actions } from '~/eds/src/components/Actions/Actions';
import { useRouting } from '~/routing/useRouting';

import { testIsInADocViewerPage } from '../../../ask-anything-button/utils';
import { Message } from '../../../types/chat';

interface Props {
  message: Message;
  onSelectSource?: (message: Message, sourceIndex: number) => void;
}
export const Sources = ({ message, onSelectSource }: Props) => {
  const intl = useIntl();
  const { location } = useRouting();

  const isDocViewerPage = useMemo(
    () => testIsInADocViewerPage(location.pathname),
    [location.pathname],
  );

  const sources = useMemo(() => {
    return (message.sources ?? []).map((_source, index) => ({
      level: 'secondary' as const,
      text: `${index + 1}`,
      tooltip: !isDocViewerPage
        ? intl.formatMessage({
            id: 'Sources.notAvailableTooltip',
            defaultMessage:
              'Source highlights are accessible when viewing the document version.',
            description: 'Tooltip when source highlights are not available',
          })
        : intl.formatMessage(
            {
              id: 'Sources.viewSourceTooltip',
              defaultMessage: 'View source {sourceNumber}',
              description:
                'Tooltip for viewing a source. Example: sourceNumber = 1, 2, 3',
            },
            {
              sourceNumber: index + 1,
            },
          ),
      onClick: () => {
        onSelectSource?.(message, index);
      },
      disabled: !isDocViewerPage,
    }));
  }, [message, isDocViewerPage]);

  if (!message.sources?.length) return null;

  return <Actions wrap actions={sources} size="xs" />;
};
